import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0B4064', 
    },
    secondary: {
      main: '#0b4064', 
    },
    error: {
      main: '#d32f2f', // red color
    },
  },
});

export default theme;